import { useEffect, useState } from "react";
import { isStoredCardValid } from "../lib/preparednessReward";

/**
 * Reactive `isStoredCardValid()` hook — re-checks on:
 *   - mount
 *   - our own `sos.card.saved` custom event (fired by SOSIdentityCard on save)
 *   - cross-tab `storage` events on `sos_identity_card`
 *
 * The `fallbackServerFlag` arg lets a parent force-show the badge when the
 * server already knows the user is prepared (e.g. logged in from a device
 * that doesn't have the card in localStorage).
 */
export function usePreparedBadge(fallbackServerFlag = false) {
  const [valid, setValid] = useState(() => isStoredCardValid());

  useEffect(() => {
    const refresh = () => setValid(isStoredCardValid());
    const onStorage = (e) => {
      if (e.key === "sos_identity_card" || e.key === null) refresh();
    };
    window.addEventListener("sos.card.saved", refresh);
    window.addEventListener("storage", onStorage);
    // One extra refresh in case the card was written in the same tick as mount.
    refresh();
    return () => {
      window.removeEventListener("sos.card.saved", refresh);
      window.removeEventListener("storage", onStorage);
    };
  }, []);

  return valid || !!fallbackServerFlag;
}
